<template>
  <ODialog ref="dialog" :maxWidth="900" hideWhenLoading>
    <v-card v-if="mailbox != null">
      <ODialogBar title="Debug Wifi" @close="dismiss" />
      <v-tabs v-model="currentTab" background-color="transparent">
        <v-tab>Lista</v-tab>
        <v-tab>JSON</v-tab>
        <v-tab>Mailbox</v-tab>
      </v-tabs>

      <v-tabs-items v-model="currentTab">
        <v-tab-item class="maxh-5">
          <WifiViewer :networks="mailbox.originJson.networks" />
        </v-tab-item>
        <v-tab-item>
          <v-card-text class="maxh-5">
            <pre>{{ mailbox | prettyJson }}</pre>
          </v-card-text>
        </v-tab-item>
        <v-tab-item>
          <v-card-text class="maxh-5">
            <v-btn small @click="copyToClipboard" class="mb-4">
              <v-icon small>mdi-clipboard</v-icon>
              Copiar para o Clipboard
            </v-btn>
            <div>
              <pre>{{ addrLine }}</pre>
              <pre v-if="mailbox.originJson.hasError">ERROR</pre>
              <pre>{{ mailbox.originJson.bytes }}</pre>
            </div>
          </v-card-text>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </ODialog>
</template>

<script>
import { Vehicle, WifiAssoc } from '../../../models/index.js'
import brush from 'brush'
import WifiViewer from './WifiViewer.vue'

export default {
  components: { WifiViewer },
  data() {
    return {
      currentTab: 0,
      mailbox: null,
      vehicleId: null
    }
  },
  computed: {
    addrLine() {
      if (this.mailbox == null) return null
      let a = this.mailbox.originJson.address.toString(16).padStart(4, '0')
      let h = this.mailbox.originJson.bytes
      let l = brush.hexToBytes(h).length
      return `STORE 0x${a} (${l} bytes)\n\n`
    }
  },
  methods: {
    open(vehicleId) {
      this.vehicleId = vehicleId
      this.$refs.dialog.$loading(() => this.fetchData())
      this.$refs.dialog.$open()
    },
    dismiss() {
      this.$refs.dialog.$dismiss()
    },
    async fetchData() {
      let vehicle = await Vehicle.findById(this.vehicleId)
      let res = await WifiAssoc.findByVehicle(this.vehicleId)
      let networkIds = res.map((x) => x.networkId)

      let label = `Veículo #${vehicle.id} ${vehicle.code}`
      let clientId = vehicle.clientId
      this.mailbox = await WifiAssoc.previewMailbox({
        networkIds,
        label,
        clientId
      })
    },

    copyToClipboard() {
      if (this.mailbox == null) return null
      navigator.clipboard.writeText(JSON.stringify(this.mailbox, null, ' '))
      this.$snack(`Mailbox copiado`)
    }
  }
}
</script>

<style></style>
